import { useQuery } from "@tanstack/react-query";
import {
  type EntityListOfTransactionItem,
  getTransactionsRefunds,
  TransactionStatus,
} from "Infrastructure/Api/Api";
import { MS_TIME } from "Utils/TimeUtils";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const TRANSACTIONS_REFUNDS_QUERY_KEY = "TRANSACTIONS_REFUNDS";

export const transactionsRefundsKeys = {
  all: [TRANSACTIONS_REFUNDS_QUERY_KEY],
  byParams: (offset?: number, limit?: number) => [
    ...transactionsRefundsKeys.all,
    offset,
    limit,
  ],
};

const ALLOWED_STATUSES = [
  TransactionStatus.Created,
  TransactionStatus.Initiated,
  TransactionStatus.Processing,
];

type Props = {
  offset?: number;
  limit?: number;
  allowedStatuses?: Array<TransactionStatus>;
};

export const useTransactionsRefunds = ({ offset, limit }: Props = {}) =>
  useQuery<EntityListOfTransactionItem>({
    queryKey: transactionsRefundsKeys.byParams(offset, limit),
    queryFn: processResponseWithApiProblemDetails(() =>
      getTransactionsRefunds(offset, limit, ALLOWED_STATUSES),
    ),
    refetchOnWindowFocus: false,
    staleTime: 5 * MS_TIME.minute,
  });
